import React from 'react';
import cx from 'classnames';

export const renderInput = ({
  input,
  type,
  meta: { touched, error },
  className,
  disabled
}) => (
  <input
    {...input}
    type={type}
    className={cx(className, {
      error: touched && error
    })}
    disabled={disabled}
  />
);

export const renderSelect = ({
  input,
  meta: { touched, error },
  children,
  className,
  disabled
}) => (
  <select
    {...input}
    className={cx(className, {
      error: touched && error
    })}
    disabled={disabled}
  >
    {children}
  </select>
);
